/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationInputModel {
    getFixupPrototypeFunction() { return NotificationInputModel.fixupPrototype; }

    static newInstance(model: Partial<NotificationInputModel>): NotificationInputModel {
        let obj = Object.assign(new NotificationInputModel(), model);
        NotificationInputModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationInputModel>): NotificationInputModel {
        if (!model) return null;
        return NotificationInputModel.newInstance(<NotificationInputModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationInputModel) {
        if (!obj) return;

        models.NotificationInputModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationInputModel): boolean {
        Object.setPrototypeOf(obj, NotificationInputModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Email id List
     */
    emails: Array<string>;

    /**
     * Webhook Urls to send alerts
     */
    webhook_urls: Array<string>;

}
